import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import BellIcon from 'icons/Bell.icon';

import './NewBadge.styles.scss';

type NewBadgeProps = {
  className?: string;
};

const NewBadge: React.FC<NewBadgeProps> = (props) => {
  const { className } = props;

  const classes = classNames('new-badge', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      {t('new')} <BellIcon />
    </div>
  );
};

export default NewBadge;
